import { Routes } from '@backoffice-frontend/common'
import { FormPasswordfield, FormTextfield } from '@backoffice-frontend/forms'
import { MoiaGrid, MoiaLink } from '@backoffice-frontend/patterns'
import { usePaceValidators } from '@backoffice-frontend/validators'
import { Button, LoadingIndicator } from '@moia-dev/pace-web'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const LoginForm = ({
  onSubmit,
  isMobile,
  onClose,
}: {
  onSubmit: (values: { username: string; password: string }) => Promise<void>
  isMobile: boolean
  onClose: VoidFunction
}) => {
  const { t } = useTranslation()
  const { handleSubmit, control, formState } = useForm({
    mode: 'onChange',
    defaultValues: {
      username: '',
      password: '',
    },
  })
  const { required } = usePaceValidators()

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <MoiaGrid gridGap={isMobile ? 1 : 2} mt={isMobile ? 1 : 3}>
        <FormTextfield
          size={isMobile ? 'compact' : 'default'}
          control={control}
          autoComplete="email"
          name="username"
          rules={{ required }}
          label={t('common_email_label')}
          forceLowerCase
        />
        <FormPasswordfield
          size={isMobile ? 'compact' : 'default'}
          control={control}
          name="password"
          autoComplete="current-password"
          rules={{ required }}
          label={t('common_password_label')}
        />
      </MoiaGrid>
      <MoiaGrid
        mt={isMobile ? 1 : 3}
        gridGap={1}
        gridTemplateColumns="1fr min-content min-content"
      >
        <MoiaLink type="primary" to={Routes.Auth.ForgotPassword.url}>
          {t('loginView_forgotPassword_textlink')}
        </MoiaLink>
        <Button
          variant="secondary"
          onClick={onClose}
          label={t('common_back_button')}
          size="compact"
        />
        <Button
          type="submit"
          variant="primary"
          size="compact"
          disabled={formState.isSubmitting}
          label={t('loginView_login_button')}
          icon={formState.isSubmitting ? <LoadingIndicator /> : undefined}
        />
      </MoiaGrid>
    </form>
  )
}
